import * as React from "react";
import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import App from "./App";
import './plugin/i18n';
import {HelmetProvider} from "react-helmet-async";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);


root.render(
    <StrictMode>
        <HelmetProvider>
            <App/>
        </HelmetProvider>
    </StrictMode>
);
